import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from "../app-material/app-material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { FlashMessagesModule } from "angular2-flash-messages";
import { MntMasterModule } from "../mnt-master/mnt-master.module";
import { MntInvoicesRoutingModule } from './mnt-invoices-routing.module';
import { InvoicesListComponent } from './invoices-list/invoices-list.component';
import { InvoicesFormComponent } from './invoices-form/invoices-form.component';
import { InvoiceItemComponent } from './invoice-item/invoice-item.component';
import { CheckOutComponent } from './check-out/check-out.component';
import { PaymentRefundComponent } from './payment-refund/payment-refund.component';
import { ShippingInfoComponent } from './shipping-info/shipping-info.component';
import { ReversePipe } from './reverse-arr.pipe';
//import {TimeAgoPipe} from 'time-ago-pipe';
import { PayPalPaymentComponent } from './pay-pal-payment/pay-pal-payment.component';
import { UpdateInvoiceAddressComponent } from './update-invoice-address/update-invoice-address.component';
import { ProductListComponent } from './product-list/product-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AddProductStepComponent } from './add-product-step/add-product-step.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductModelPhotoComponent } from './product-model-photo/product-model-photo.component';
import { OwnGarmentComponent } from './own-garment/own-garment.component';
import { ProductQuantityComponent } from './product-quantity/product-quantity.component';
import { PrintSpecsComponent } from './print-specs/print-specs.component';
import { InkTypeComponent } from './ink-type/ink-type.component';
import { FinishingComponent } from './finishing/finishing.component';
import { InkColorPickerComponent } from './ink-color-picker/ink-color-picker.component';
import { PfArtfileComponent } from './pf-artfile/pf-artfile.component';
import { DragulaModule } from 'ng2-dragula';
import { SaveQuoteComponent } from './save-quote/save-quote.component';
import { GuestEmailComponent } from './guest-email/guest-email.component';
import { MailPublicUrlComponent } from './mail-public-url/mail-public-url.component';
import { TermInvoiceComponent } from './term-invoice/term-invoice.component';
import { AssignStaffComponent } from './assign-staff/assign-staff.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { AddTaskComponent } from './add-task/add-task.component';
import { OverrideStockComponent } from './override-stock/override-stock.component';
import { MntStoresModule } from '../mnt-stores/mnt-stores.module';
import { SquareupResponseComponent } from './squareup-response/squareup-response.component';
import { ClientAddressEditComponent } from './client-address-edit/client-address-edit.component';
import { ClientAddressFormComponent } from './client-address-form/client-address-form.component';
import { PrintInvoiceComponent } from './print-invoice/print-invoice.component';
import { AssignToStoreComponent } from './assign-to-store/assign-to-store.component';
import { SmsPublicUrlComponent } from './sms-public-url/sms-public-url.component';
import { QRCodeModule } from 'angularx-qrcode';
import { MntProductsModule } from '../mnt-products/mnt-products.module';
import { PurchaseOrderListComponent } from './purchase-order-list/purchase-order-list.component';
import { VendorListComponent } from './vendor-list/vendor-list.component';
import { VendorFormComponent } from './vendor-form/vendor-form.component';

export const options: Partial<IConfig> = {
};

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    ReactiveFormsModule,
    MntInvoicesRoutingModule,
    MntMasterModule,
    FormsModule,
    SharedModule,
    FlashMessagesModule,
    InfiniteScrollModule,
    MntStoresModule,
    DragulaModule.forRoot(),
    NgxMaskModule.forRoot(options),
    QRCodeModule,
    MntProductsModule
  ],
  declarations: [InvoicesListComponent, InvoicesFormComponent, InvoiceItemComponent, CheckOutComponent, PaymentRefundComponent, ShippingInfoComponent, ReversePipe, PayPalPaymentComponent, UpdateInvoiceAddressComponent, ProductListComponent, AddProductStepComponent, ProductDetailComponent, ProductModelPhotoComponent, OwnGarmentComponent, ProductQuantityComponent, PrintSpecsComponent, InkTypeComponent, FinishingComponent, InkColorPickerComponent, PfArtfileComponent, SaveQuoteComponent, GuestEmailComponent, MailPublicUrlComponent, TermInvoiceComponent, AssignStaffComponent, AddTaskComponent, OverrideStockComponent, SquareupResponseComponent, ClientAddressEditComponent, ClientAddressFormComponent, PrintInvoiceComponent, AssignToStoreComponent, SmsPublicUrlComponent, PurchaseOrderListComponent, VendorListComponent, VendorFormComponent],
  entryComponents: [AddTaskComponent, InvoiceItemComponent, CheckOutComponent, PaymentRefundComponent, ShippingInfoComponent, UpdateInvoiceAddressComponent, ProductDetailComponent, ProductModelPhotoComponent, OwnGarmentComponent, InkColorPickerComponent, PfArtfileComponent, SaveQuoteComponent, GuestEmailComponent, MailPublicUrlComponent, AssignStaffComponent, OverrideStockComponent, SquareupResponseComponent, ClientAddressEditComponent, ClientAddressFormComponent, AssignToStoreComponent, SmsPublicUrlComponent, VendorFormComponent],
  exports: [InvoicesListComponent, InvoicesFormComponent, InvoiceItemComponent, CheckOutComponent, PaymentRefundComponent, ShippingInfoComponent, ReversePipe, PayPalPaymentComponent, UpdateInvoiceAddressComponent, ProductListComponent, AddProductStepComponent, ProductDetailComponent, ProductModelPhotoComponent, OwnGarmentComponent, ProductQuantityComponent, PrintSpecsComponent, InkTypeComponent, FinishingComponent, InkColorPickerComponent, PfArtfileComponent, SaveQuoteComponent, GuestEmailComponent, MailPublicUrlComponent, TermInvoiceComponent, AssignStaffComponent, AddTaskComponent, OverrideStockComponent, SmsPublicUrlComponent],
})
export class MntInvoicesModule {
  PaymentRefundComponent;
  InvoiceItemComponent;
  ProductDetailComponent;
  ShippingInfoComponent;
  MailPublicUrlComponent;
  PayPalPaymentComponent;
  SmsPublicUrlComponent;
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/mnt-invoices.module.ts